<template>
    <div id="mobile-detail-acq-f-t-cta">
        <!--/* message d'alerte en cas d'absence de ctas */-->
        <div v-if="offersHref == null && onlineHref == null && eresaHref == null" class="row">
            <div class="col-12 pt-2">
                <ob1-message-alerte
                    :is-simple-alerte="false"
                    :title="alertStatusDto.title"
                    :text="alertStatusDto.message"
                    :type="'warning'"
                />
            </div>
        </div>

        <!--/* Si pas choix de forfait mobile dans l'url ni panier FM ou FMR */-->
        <div v-else-if="offersHref">
            <!--/* le cas juste un I dans le panier alors vers page panier FMR */-->
            <div v-if="withDigitalCartInternet">
                <mobileDetailsCtaAndAvailabilityMentions
                    :available-online="availableOnline"
                    :estimated-delivery-label="estimatedDeliveryLabel"
                    :available-eresa="availableEresa"
                    :preorder-mention="preorderMention"
                    :label="buttonLabel"
                    :href="offersHref"
                />
            </div>
            <div v-else>
                <!--/* le cas sans I dans le panier alors vers page authent choix entre compte internet (FMR) non internet (FM) */ -->
                <!--/* puis on enchaine vers selecteur des forfaits */-->
                <mobileDetailsCtaAndAvailabilityMentions
                    :available-online="availableOnline"
                    :estimated-delivery-label="estimatedDeliveryLabel"
                    :available-eresa="availableEresa"
                    :preorder-mention="preorderMention"
                    :label="buttonLabel"
                    :href="authPopinConfig ? null : offersHref"
                    :data-target="authPopinConfig ? '#authenticationPopIn' : null"
                />
            </div>
        </div>

        <!--/* Si choix de forfait dans l'url ou panier FM ou FMR */-->
        <!--/* Les ctas TDC et C&C sont à afficher : on les affiche dans une popin TDC ou C&C */-->
        <div v-else-if="onlineHref && eresaHref">
            <!--/* le cas panier vide vers l'autent  puis en enchaine sur selecteur des forfait */-->
            <!--/* le cas panier non vide vers page panier  FM ou FMR selon le contenu du panier */-->
            <mobileDetailsCtaAndAvailabilityMentions
                :available-online="availableOnline"
                :estimated-delivery-label="estimatedDeliveryLabel"
                :available-eresa="availableEresa"
                :label="buttonLabel"
                :preorder-mention="preorderMention"
                :data-target="'#allDisponibilitiesPopIn'"
            />
            <all-disponibilities-popin
                :title="allDisponibilitiesPopin.title"
                :tdc-section="allDisponibilitiesPopin.tdcSection"
                :eresa-section="allDisponibilitiesPopin.eresaSection"
                :eco-foot-note="allDisponibilitiesPopin.ecoFootNote"
                :tdc-href="onlineHref"
                :eresa-href="eresaHref"
                :chain-to-auth-on-online="authPopinConfig ? needsAuth : false"
                @online-click-requires-auth="openAuthenticationAfterDisponibilities"
            />
        </div>

        <!--/* Seul le cta TDC ou celui du C&C est actif : on l'affiche dans le coeur de page */-->
        <div v-else>
            <div v-if="onlineClientHref && needsAuth">
                <!--/* le cas panier vide vers l'autent  puis en enchaine sur selecteur des forfait */-->
                <!--/* le cas panier non vide vers page panier  FM ou FMR selon le contenu du panier */-->
                <mobileDetailsCtaAndAvailabilityMentions
                    :available-online="availableOnline"
                    :estimated-delivery-label="estimatedDeliveryLabel"
                    :available-eresa="availableEresa"
                    :preorder-mention="preorderMention"
                    :label="buttonLabel"
                    :href="authPopinConfig ? null : onlineHref"
                    :data-target="authPopinConfig ? '#authenticationPopIn' : null"
                />
            </div>
            <div v-else>
                <!--/* cta TDC */-->
                <mobileDetailsCtaAndAvailabilityMentions
                    :available-online="availableOnline"
                    :estimated-delivery-label="estimatedDeliveryLabel"
                    :available-eresa="availableEresa"
                    :preorder-mention="preorderMention"
                    :label="buttonLabel"
                    :href="onlineHref ? onlineHref : eresaHref"
                />
            </div>
        </div>

        <!--/* Popin d'authent  */-->
        <authentication-popin
            v-if="authPopinConfig"
            :id="'authenticationPopIn'"
            :title="authenticationPopinLabels.title"
            :subtitle="authenticationPopinLabels.subtitle"
            :new-client-title="authenticationPopinLabels.newClientTitle"
            :new-client-description="authenticationPopinLabels.newClientDescription"
            :new-client-href="authPopinConfig.newClientHref"
            :client-title="authenticationPopinLabels.alreadyClientTitle"
            :client-description="authenticationPopinLabels.alreadyClientDescription"
            :client-href="authPopinConfig.clientHref"
        />
    </div>
</template>

<script>

import AllDisponibilitiesPopin from "../../common/components/AllDisponibilitiesPopin.vue";
import MobileDetailsCtaAndAvailabilityMentions
    from "../../common/mobiledetails/MobileDetailsCtaAndAvailabilityMentions.vue";
import AuthenticationPopin from "./AuthenticationPopin.vue";

export default {
    name: "MobileDetailsCtaAcquisition",
    components: {
        AuthenticationPopin,
        MobileDetailsCtaAndAvailabilityMentions,
        AllDisponibilitiesPopin,
    },
    props: {
        offersHref: {
            type: String,
            required: false,
            default: null
        },
        offersClientHref: {
            type: String,
            required: false,
            default: null
        },
        onlineHref: {
            type: String,
            required: false,
            default: null
        },
        onlineClientHref: {
            type: String,
            required: false,
            default: null
        },
        eresaHref: {
            type: String,
            required: false,
            default: null
        },
        alertStatusDto: {
            type: Object,
            required: true
        },
        allDisponibilitiesPopin: {
            type: Object,
            required: true
        },
        buttonLabel: {
            type: String,
            required: true
        },
        preorderMention: {
            type: String,
            required: false,
            default: null
        },
        availableOnline: {
            type: Boolean,
            required: true
        },
        estimatedDeliveryLabel: {
            type: String,
            default: null
        },
        availableEresa: {
            type: Boolean,
            required: true
        },
        authenticationPopinLabels: {
            type: Object,
            required: false,
            default: null
        },
        withDigitalCartInternet: {
            type: Boolean,
            required: false,
            default: false
        },
        hasOfferFromUrl: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        needsAuth() {
            //Méthode propre au panier activée
            return !!(this.authenticationPopinLabels && this.hasOfferFromUrl && !this.withDigitalCartInternet);
        },
        authPopinConfig() {
            // Cas 1 : pas d'offre dans l'url ni panier → selecteur des forfaits
            if (this.offersHref && this.authenticationPopinLabels) {
                return {
                    newClientHref: this.offersHref,
                    clientHref: this.offersClientHref
                };
            }

            // Cas 2 : TDC + eresa (all-disponibilities enchaîné vers authent)
            if (this.needsAuth
                && this.onlineHref
                && this.eresaHref
                && this.onlineClientHref) {
                return {
                    newClientHref: this.onlineHref,
                    clientHref: this.onlineClientHref || this.onlineHref
                };
            }

            // Cas 3 : TDC seul
            if (this.needsAuth && this.onlineClientHref && this.onlineHref) {
                return {
                    newClientHref: this.onlineHref,
                    clientHref: this.onlineClientHref
                };
            }

            return null;
        }
    },
    methods: {
        openAuthenticationAfterDisponibilities() {
            const allPopin = $('#allDisponibilitiesPopIn');
            allPopin.off('hidden.bs.modal')           // ① évite les doublons de listeners
                .one('hidden.bs.modal', () => {
                    $('#authenticationPopIn').modal('show'); // ③ s'ouvre APRÈS fermeture complète
                });
            allPopin.modal('hide');                   // ② déclenche la fermeture
        }
    }
}
</script>
